import styled from 'styled-components';
import {
  Colors,
  DropDownChip,
  DropDownChipProps,
  Icons,
  MultiSelectDropDownOption,
  Typography,
} from '@replai-platform/ui-components';

export interface CampaignTypeFilterProps {
  disabled?: boolean;
  /** One option per campaign type, carrying the `mode` (include/exclude/none) the user gave it. */
  options: MultiSelectDropDownOption[];
  onChange: DropDownChipProps['onChange'];
  loading: boolean;
  dropdownMaxHeightInVH?: number;
  /** Whether the project/feature has campaign types to filter by. The chip is hidden when `false`. */
  hasData?: boolean;
}

const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const LegendText = styled(Typography)`
  margin: 0;
  color: ${Colors.Gray[500]};
`;

/** Explains the two buttons every campaign type carries */
const CampaignTypeLegend = () => (
  <Legend data-test="filter-campaign-type-legend">
    <LegendItem>
      <Icons.BaseIcons.CheckCircle color={Colors.Success[600]} dimension={14} />
      <LegendText type="text-xs">Include</LegendText>
    </LegendItem>
    <LegendItem>
      <Icons.BaseIcons.MinusCircle color={Colors.Error[600]} dimension={14} />
      <LegendText type="text-xs">Exclude</LegendText>
    </LegendItem>
  </Legend>
);

const CampaignTypeFilter: React.VFC<CampaignTypeFilterProps> = ({
  disabled,
  options,
  onChange,
  loading,
  dropdownMaxHeightInVH,
}) => (
  <DropDownChip
    disabled={disabled}
    data-test="filter-campaign-type-dropdown"
    placeHolder="All Campaign Types"
    dropDownType="multiselect"
    dropDownOptions={options}
    dropDownAlignment="right"
    onChange={onChange}
    selectionMode="include-exclude"
    dropDownHeader={<CampaignTypeLegend />}
    loading={loading}
    dropdownMaxHeightInVH={dropdownMaxHeightInVH}
  />
);

export default CampaignTypeFilter;
